import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {PredlogZaSaradnjuDocument} from "./PredlogZaSaradnjuDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, tip saradnje, partner, sektor
// opciono: opis, lista priloga
export const predlogZaSaradnjuDocumentFields: IntercateKeysMap<PredlogZaSaradnjuDocument, EntityField<PredlogZaSaradnjuDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	cooperationType: {
		name: "cooperationType", dataType: EntityFieldDataType._string, label: "Tip saradnje",
		validator: { required: true },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<PredlogZaSaradnjuDocument>> = [
	predlogZaSaradnjuDocumentFields.indexingNumber,
	predlogZaSaradnjuDocumentFields.indexingDate,
	predlogZaSaradnjuDocumentFields.documentNumber,
	predlogZaSaradnjuDocumentFields.documentDate,
	predlogZaSaradnjuDocumentFields.assignedTo,
	predlogZaSaradnjuDocumentFields.clientId,
	predlogZaSaradnjuDocumentFields.sectorId,
	predlogZaSaradnjuDocumentFields.cooperationType,
	predlogZaSaradnjuDocumentFields.tags,
	predlogZaSaradnjuDocumentFields.parentId
]

export const predlogZaSaradnjuDocumentFieldsDescriptor: EntityFieldsDescriptor<PredlogZaSaradnjuDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
